import { Link } from "@tanstack/react-router";
import { ASSETS } from "#/lib/assets";
import { ROUTES } from "#/lib/routes";

interface LinkDef {
  label: string;
  to: string;
}

const INFO_LINKS: readonly LinkDef[] = [
  { label: "About Us", to: ROUTES.about },
  { label: "Frequently Asked Questions", to: ROUTES.faqs },
  { label: "Returns & Refunds", to: ROUTES.returns },
  { label: "International Shipping Policies", to: ROUTES.intlShipping },
  { label: "Shipping & Delivery", to: ROUTES.shipping },
  { label: "Privacy Policy", to: ROUTES.privacyPolicy },
];

const ACCOUNT_LINKS: readonly LinkDef[] = [
  { label: "Track Your Order", to: ROUTES.track },
  { label: "My Orders", to: ROUTES.account },
  { label: "View Cart", to: ROUTES.cart },
  { label: "My Wishlist", to: ROUTES.accountWishlist },
  { label: "Help", to: ROUTES.contact },
];

function FLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      className="block cursor-pointer font-display  text-xs md:text-base text-white leading-relaxed hover:underline"
    >
      {children}
    </Link>
  );
}

export function Footer() {
  return (
    <footer className="rounded-t-[30px] lg:rounded-t-[60px] bg-lp-green pt-16 pb-12">
      {/* <div
				className="mx-auto lg:grid w-full max-w-figma gap-14 px-10 text-white"
				style={{ gridTemplateColumns: "1fr 2px 1fr 2px 1fr" }}
			> */}
      <div className="grid grid-cols-2 lg:grid-cols-[1fr_2px_1fr_2px_1fr] text-center md:text-left mx-auto w-full max-w-figma gap-14 px-10 text-white">
        <div className="col-span-2 md:col-span-1">
          <h3 className="m-0 mb-7 font-bold font-display text-md md:text-lg text-white tracking-wide">
            CONTACT US
          </h3>
          <a
            href="tel:+63285409868"
            className="mb-4 flex justify-center md:justify-start items-center gap-3.5 text-white no-underline hover:underline"
          >
            <svg
              aria-hidden="true"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M22 17v3a2 2 0 0 1-2.2 2A19 19 0 0 1 2 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7l.5 3a2 2 0 0 1-.6 2L7.6 10a16 16 0 0 0 6.4 6.4l1.3-1.3a2 2 0 0 1 2-.6l3 .5A2 2 0 0 1 22 17z" />
            </svg>
            <span className="font-bold font-display text-xs md:text-base">
              Phone (+63 2 8540 9868)
            </span>
          </a>
          <a
            href="mailto:support@learningplus.ph"
            className="mb-5 flex justify-center md:justify-start items-center gap-3.5 text-white no-underline hover:underline"
          >
            <svg
              aria-hidden="true"
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="m3 7 9 6 9-6" />
            </svg>
            <span className="font-medium font-mono text-xs md:text-base">
              support@learningplus.ph
            </span>
          </a>
          <div className="mb-3.5 font-medium font-mono text-xs md:text-base">
            Visit our Shopee &amp; Lazada Store!
          </div>
          <div className="flex flex-col justify-center md:justify-start lg:flex-row items-center gap-4">
            <a
              href="https://shopee.ph/learningplus"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={ASSETS.shopee}
                alt="Shopee"
                className="h-8 w-auto lg:h-12 ml-3 lg:ml-0"
                loading="lazy"
                decoding="async"
              />
            </a>
            <a
              href="https://www.lazada.com.ph/shop/learning-plus-ph"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={ASSETS.lazada}
                alt="Lazada"
                className="h-10 w-auto lg:h-14 lg:mt-3"
                loading="lazy"
                decoding="async"
              />
            </a>
          </div>
        </div>
        <div className="self-stretch bg-white  hidden lg:block" />
        <div>
          <h3 className="m-0 mb-7 font-bold font-display text-md md:text-lg text-white tracking-wide">
            INFORMATION
          </h3>
          <div className="flex flex-col gap-3.5">
            {INFO_LINKS.map((l) => (
              <FLink key={l.to + l.label} to={l.to}>
                {l.label}
              </FLink>
            ))}
          </div>
        </div>
        <div className="self-stretch bg-white hidden lg:block" />
        <div>
          <h3 className="m-0 mb-7 font-bold font-display text-md md:text-lg text-white tracking-wide">
            MY ACCOUNT
          </h3>
          <div className="flex flex-col gap-3.5">
            {ACCOUNT_LINKS.map((l) => (
              <FLink key={l.to + l.label} to={l.to}>
                {l.label}
              </FLink>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
